// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"09274b21","455":"a9f2ae66","977":"161b812a"}[chunkId] + ".chunk.js";
};